import * as React from 'react'
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Logout from '@mui/icons-material/Logout'
import { FiUser } from 'react-icons/fi'
import { Button, Tooltip, useMediaQuery } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { AuthContext } from '../../contexts/Auth'
import { returnString } from '@utils/string'
import { MarqueeText } from './MarqueeText'
import { hasPermission } from '@utils/permission_helper'
import { PermissionCodeEnum } from '@models/permission'

const Flexbox = styled(Box)(() => ({
	flexDirection: 'row',
	justifyContent: 'space-between',
	display: 'flex',
	alignItems: 'center',
}))

const FlexboxItem = styled(Box)(() => ({
	display: 'inline',
}))

const ProfileMenu = (props: { handleLogout: () => void }) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { state, dispatch } = useContext(AuthContext)
	const isXSmallScreem = useMediaQuery('(max-width:414px)')

	return (
		<React.Fragment>
			<Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
				<Button variant="primaryRounded" onClick={handleClick}>
					<Typography variant="h3" color="white">
						{state.userInfo.first_name
							?.split(' ')
							.slice(0, 2)
							.map((x) => x.charAt(0))}
					</Typography>
				</Button>
			</Box>
			<Menu
				anchorEl={anchorEl}
				id="account-menu"
				open={open}
				onClose={handleClose}
				onClick={handleClose}
				PaperProps={{
					elevation: 0,
					sx: {
						display: 'flex',
						justifyContent: 'space-evenly',
						alignItems: 'center',
						overflow: 'visible',
						filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
						background: 'linear-gradient(45deg, #E9E9E9, #FFFFFF)',
						mt: 1.5,
						padding: 2,
						borderRadius: '10px',
						'& .MuiAvatar-root': {
							width: 32,
							height: 32,
							ml: -0.5,
							mr: 1,
						},
						'&:before': {
							content: '""',
							display: 'block',
							position: 'absolute',
							top: 0,
							right: 14,
							width: 10,
							height: 10,
							bgcolor: 'background.paper',
							transform: 'translateY(-50%) rotate(45deg)',
							zIndex: 0,
						},
					},
				}}
				transformOrigin={{ horizontal: 'right', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			>
				<Flexbox sx={{ alignItems: 'center', marginBottom: '12px', paddingLeft: '5px' }}>
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'cneter' }}>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								width: '30px',
								height: '34px',
							}}
						>
							<FiUser size={30} color={'#707070'} />
						</Box>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								marginLeft: '8px',
							}}
						>
							<Typography variant="h4" color="#707070">
								{t('User Profile')}
							</Typography>
						</Box>
					</Box>
					<FlexboxItem
						sx={{
							border: '1px solid #5D7DC1',
							borderRadius: '5px',
							height: '32px',
							width: '32px',
							':hover': { backgroundColor: '#C9E6FF' },
						}}
					>
						<Tooltip title="Logout" placement={'left'}>
							<IconButton
								onClick={props.handleLogout}
								sx={{ p: 0, color: '#5D7DC1', width: '32px', height: '32px' }}
							>
								<Logout />
							</IconButton>
						</Tooltip>
					</FlexboxItem>
				</Flexbox>
				<Box
					sx={{
						boxShadow: 1,
						padding: 2,
						marginY: 1,

						height: '200px',
						borderRadius: '5px',
						background: '#FFFFFF',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'space-around',
					}}
				>
					<Flexbox>
						<FlexboxItem>{t('Username:')}</FlexboxItem>
						<FlexboxItem>
							{/* <ProfileDetailsTypography>{returnString(state.userInfo.first_name) +  " " + returnString(state.userInfo.last_name)}</ProfileDetailsTypography> */}
							{
								<MarqueeText
									text={
										returnString(state.userInfo.first_name) +
										' ' +
										returnString(state.userInfo.last_name)
									}
								></MarqueeText>
							}
						</FlexboxItem>
					</Flexbox>
					<Divider />
					<Flexbox>
						<FlexboxItem>{t('Organisation:')}</FlexboxItem>
						<FlexboxItem>
							{/* <ProfileDetailsTypography>{t(state.userInfo.company)}</ProfileDetailsTypography> */}
							<MarqueeText text={t(state.userInfo.company || '')}></MarqueeText>
						</FlexboxItem>
					</Flexbox>
					<Divider />
					<Flexbox>
						<FlexboxItem>{t('Email:')}</FlexboxItem>
						<FlexboxItem>
							{/* <ProfileDetailsTypography>{t(state.userInfo.email)}</ProfileDetailsTypography> */}
							<MarqueeText text={t(state.userInfo.email)}></MarqueeText>
						</FlexboxItem>
					</Flexbox>
					<Divider />
					<Flexbox>
						<FlexboxItem>{t('Position:')}</FlexboxItem>
						<FlexboxItem>
							{/* <ProfileDetailsTypography>{t(state.userInfo.position)}</ProfileDetailsTypography> */}
							<MarqueeText text={t(state.userInfo.position || '')}></MarqueeText>
						</FlexboxItem>
					</Flexbox>
					<Divider />
					<Flexbox>
						<FlexboxItem>{t('Phone:')}</FlexboxItem>
						<FlexboxItem>
							{/* <ProfileDetailsTypography>{t(state.userInfo.phone)}</ProfileDetailsTypography> */}
							<MarqueeText text={t(state.userInfo.phone || '')}></MarqueeText>
						</FlexboxItem>
					</Flexbox>
					<Divider />
				</Box>
				{hasPermission(state?.userInfo, [PermissionCodeEnum.ConfigurationMenu]) ? (
					<Button
						sx={{
							width: '100%',
							height: '44px',
							boxShadow: 1,
							marginTop: 1,
							background: '#FFFFFF',
							':hover': { backgroundColor: '#C9E6FF' },
						}}
						onClick={() => {
							window.location.pathname.includes('configurations')
								? navigate('/')
								: navigate('/configurations/users_config')
						}}
					>
						<Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'black' }}>
							{window.location.pathname.includes('configurations')
								? t('Back To Landing Page')
								: t('Configuration')}
						</Typography>
					</Button>
				) : null}
			</Menu>
		</React.Fragment>
	)
}
export default ProfileMenu
